import { render, staticRenderFns } from "./featurenewfof.vue?vue&type=template&id=13bcd184&scoped=true&"
import script from "./featurenewfof.vue?vue&type=script&lang=js&"
export * from "./featurenewfof.vue?vue&type=script&lang=js&"
import style0 from "./featurenewfof.vue?vue&type=style&index=0&id=13bcd184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bcd184",
  null
  
)

export default component.exports